import { DisclaimerProps } from 'components/Product/StatsSpot/statsSpotTypes';

export const Disclaimer = ({ text }: DisclaimerProps) => {
  return (
    <>
      {!!text?.value && (
        <p className="paragraph-small" dangerouslySetInnerHTML={{ __html: text.value }} />
      )}
    </>
  );
};
